import { render, staticRenderFns } from "./ContentLoop.vue?vue&type=template&id=4100d554&"
import script from "./ContentLoop.vue?vue&type=script&lang=js&"
export * from "./ContentLoop.vue?vue&type=script&lang=js&"
import style0 from "./ContentLoop.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Heading: require('/opt/build/repo/storefront/components/molecules/Row/Heading.vue').default,Banner: require('/opt/build/repo/storefront/components/molecules/Banner/Banner.vue').default,Standfirst: require('/opt/build/repo/storefront/components/molecules/Row/Standfirst.vue').default,BaseDivider: require('/opt/build/repo/storefront/components/atoms/Layout/BaseDivider.vue').default,ProductCard: require('/opt/build/repo/storefront/components/molecules/Product/ProductCard.vue').default,ProductData: require('/opt/build/repo/storefront/components/molecules/Product/ProductData.js').default,Stack: require('/opt/build/repo/storefront/components/molecules/Stack/Stack.vue').default,BannerCard: require('/opt/build/repo/storefront/components/molecules/Banner/BannerCard.vue').default,BaseColumn: require('/opt/build/repo/storefront/components/atoms/Layout/BaseColumn.vue').default,BaseVideo: require('/opt/build/repo/storefront/components/atoms/Media/BaseVideo.vue').default,RichText: require('/opt/build/repo/storefront/components/atoms/Text/RichText.vue').default,BaseLayout: require('/opt/build/repo/storefront/components/atoms/Layout/BaseLayout.vue').default})
